import get from "lodash.get";
import React, { FC } from "react";
import {
	useController,
	useFormContext,
	useFormState,
	useWatch
} from "react-hook-form";

interface Props {
	stepNumber: number;
	order: number;
	isDisabled?: boolean;
}

const TimeStep: FC<Props> = ({ stepNumber, order, isDisabled }) => {
	const { control } = useFormContext<BannerFormState>();

	const placeholder = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.placeholder`
	});

	const { errors } = useFormState({ control });

	const isAnswerInvalid = Boolean(
		get(errors, `steps[${stepNumber - 1}].fields[${order - 1}]`, null)
	);

	const { field } = useController({
		name: `steps.${stepNumber - 1}.fields.${order - 1}.givenAnswer`,
		control,
		rules: { required: !isDisabled }
	});

	return (
		<input
			id={`step-${stepNumber}`}
			type="time"
			placeholder={placeholder}
			aria-label={`step-${stepNumber}-order-${order}`}
			disabled={isDisabled}
			className={[
				"w-full px-3 py-2 text-sm bg-white rounded-md border",
				isAnswerInvalid ? "border-destructive" : "border-transparent",
				"focus:outline-none focus:ring-2 focus:ring-ring",
				"disabled:opacity-50 disabled:cursor-not-allowed"
			].join(" ")}
			{...field}
		/>
	);
};

export default TimeStep;
